export const validatePostalCode = `
  query ValidatePostalCode($postalCode: String!) {
    validatePostalCode(postalCode: $postalCode) {
      doesExist
    }
  }
`;
